import { authenticatedFetch } from '../utils/apiInterceptor';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const walletService = {
  // Initiate payment with PayU

  async walletRecharge(brandId, creditsToBuy, token) {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/api/payments/wallet/recharge/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          brand_id: brandId,
          credits_to_buy: creditsToBuy
        }),
      });

      return await response.json();
    } catch (error) {
      console.error('Payment initiation error:', error);
      throw error;
    }
  },

  // Check wallet balance
  async checkWalletBalance(token, brandId) {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/api/payments/wallets/balance/${brandId}/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      return await response.json();
    } catch (error) {
      console.error('Wallet balance check error:', error);
      throw error;
    }
  },

  // Check payment status
  async getPaymentStatus(transactionId, token) {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/api/payments/status/${transactionId}/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      return await response.json();
    } catch (error) {
      console.error('Payment status check error:', error);
      throw error;
    }
  },

  // Submit form to PayU gateway
  submitToPayU(paymentData, paymentUrl) {
    if (!paymentUrl || !paymentData || typeof paymentData !== 'object') {
      console.error('Invalid payment data or URL provided');
      return;
    }

    // Create a form dynamically and submit to PayU
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = paymentUrl;
    form.style.display = 'none';

    // Add all payment data as hidden inputs
    Object.keys(paymentData).forEach(key => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = paymentData[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  },

  // Get active credit bundles
  async getActiveBundles(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/wallet/bundles/active/`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to get active bundles: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Get active bundles error:', error);
      throw error;
    }
  },

  // Purchase a credit bundle
  async purchaseBundle(brandId, bundleId, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/payments/bundles/purchase/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({
          brand_id: brandId,
          bundle_id: bundleId
        }),
      });

      if (!response.ok) {
        try {
          const errorData = await response.json();
          // Create a custom error object with status and data for specific handling
          const error = new Error(errorData.error || errorData.message || `Bundle purchase failed: ${response.status}`);
          error.status = response.status;
          error.data = errorData;
          throw error;
        } catch (parseError) {
          // If it's already our custom error, re-throw it
          if (parseError.status) {
            throw parseError;
          }
          // Otherwise create a generic error
          throw new Error(`Bundle purchase failed: ${response.status} ${response.statusText}`);
        }
      }

      return await response.json();
    } catch (error) {
      console.error('Bundle purchase error:', error);
      throw error;
    }
  }
};
